<template>
  <div class="download-report-container">
    <!-- Page Header (PRD Section 8) -->
    <div class="page-header mb-3 pl-1">
      <!-- <h4 class="page-header-title">Internal Data Export</h4> -->
      <p class="page-header-subtitle">Generate and download centralized report data.</p>
    </div>

    <!-- Generate Data Card (PRD Section 9, 10, 11) -->
    <div class="innerBox generate-data-card">
      <div class="section-card-header mb-3">
        <h5 class="section-title">Generate Data</h5>
      </div>

      <div class="row align-items-start generate-form-row">
        <!-- Start Date Picker -->
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-3">
          <label class="form-field-label">
            Start Date <span class="text-danger">*</span>
          </label>
          <div
            class="filter-date pl-2 w-full bg-white d-flex align-items-center elegant-date-box"
            :class="{ 'has-field-error': validationErrors.startDate }"
          >
            <a class="input-button px-2" data-toggle style="display: flex; align-items: center;">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.9659 1.79591H13.17V0.598648C13.17 0.268019 12.902 0 12.5714 0C12.2407 0 11.9727 0.268019 11.9727 0.598648V1.79591H4.78908V0.598648C4.78908 0.268019 4.52106 0 4.19047 0C3.85987 0 3.59182 0.268019 3.59182 0.598648V1.79591H1.79591C0.804056 1.79591 0 2.59997 0 3.59182V14.9659C0 15.9578 0.804056 16.7618 1.79591 16.7618H14.9659C15.9578 16.7618 16.7618 15.9578 16.7618 14.9659V3.59182C16.7618 2.59997 15.9578 1.79591 14.9659 1.79591ZM15.5645 14.9659C15.5645 15.2966 15.2965 15.5646 14.9659 15.5646H1.79591C1.46528 15.5646 1.19726 15.2966 1.19726 14.9659V7.18364H15.5645V14.9659ZM15.5645 5.98638H1.19726V3.59182C1.19726 3.26119 1.46528 2.99317 1.79591 2.99317H3.59182V4.19043C3.59182 4.52106 3.85984 4.78908 4.19047 4.78908C4.5211 4.78908 4.78912 4.52106 4.78912 4.19043V2.99317H11.9728V4.19043C11.9728 4.52106 12.2408 4.78908 12.5714 4.78908C12.902 4.78908 13.1701 4.52106 13.1701 4.19043V2.99317H14.966C15.2966 2.99317 15.5646 3.26119 15.5646 3.59182L15.5645 5.98638Z"
                  fill="#2D2D2D"
                />
              </svg>
            </a>
            <flat-pickr
              :config="startDateConfig"
              placeholder="Select Start Date"
              v-model="form.startDate"
              @on-change="handleStartDateChange"
              class="flex-grow-1"
            />
            <a
              v-if="form.startDate"
              href="javascript:void(0)"
              class="px-2 clear-date-btn"
              @click="clearStartDate"
              title="Clear Start Date"
            >
              <i class="fas fa-times"></i>
            </a>
          </div>
          <small v-if="validationErrors.startDate" class="field-error-msg text-danger">
            {{ validationErrors.startDate }}
          </small>
        </div>

        <!-- End Date Picker -->
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-3">
          <label class="form-field-label">
            End Date <span class="text-danger">*</span>
          </label>
          <div
            class="filter-date pl-2 w-full bg-white d-flex align-items-center elegant-date-box"
            :class="{ 'has-field-error': validationErrors.endDate }"
          >
            <a class="input-button px-2" data-toggle style="display: flex; align-items: center;">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.9659 1.79591H13.17V0.598648C13.17 0.268019 12.902 0 12.5714 0C12.2407 0 11.9727 0.268019 11.9727 0.598648V1.79591H4.78908V0.598648C4.78908 0.268019 4.52106 0 4.19047 0C3.85987 0 3.59182 0.268019 3.59182 0.598648V1.79591H1.79591C0.804056 1.79591 0 2.59997 0 3.59182V14.9659C0 15.9578 0.804056 16.7618 1.79591 16.7618H14.9659C15.9578 16.7618 16.7618 15.9578 16.7618 14.9659V3.59182C16.7618 2.59997 15.9578 1.79591 14.9659 1.79591ZM15.5645 14.9659C15.5645 15.2966 15.2965 15.5646 14.9659 15.5646H1.79591C1.46528 15.5646 1.19726 15.2966 1.19726 14.9659V7.18364H15.5645V14.9659ZM15.5645 5.98638H1.19726V3.59182C1.19726 3.26119 1.46528 2.99317 1.79591 2.99317H3.59182V4.19043C3.59182 4.52106 3.85984 4.78908 4.19047 4.78908C4.5211 4.78908 4.78912 4.52106 4.78912 4.19043V2.99317H11.9728V4.19043C11.9728 4.52106 12.2408 4.78908 12.5714 4.78908C12.902 4.78908 13.1701 4.52106 13.1701 4.19043V2.99317H14.966C15.2966 2.99317 15.5646 3.26119 15.5646 3.59182L15.5645 5.98638Z"
                  fill="#2D2D2D"
                />
              </svg>
            </a>
            <flat-pickr
              :config="endDateConfig"
              placeholder="Select End Date"
              v-model="form.endDate"
              @on-change="handleEndDateChange"
              class="flex-grow-1"
            />
            <a
              v-if="form.endDate"
              href="javascript:void(0)"
              class="px-2 clear-date-btn"
              @click="clearEndDate"
              title="Clear End Date"
            >
              <i class="fas fa-times"></i>
            </a>
          </div>
          <small v-if="validationErrors.endDate" class="field-error-msg text-danger">
            {{ validationErrors.endDate }}
          </small>
        </div>

        <!-- Generate Action Button -->
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-3 align-self-start btn-generate-wrapper">
          <label class="form-field-label d-none d-md-block" style="visibility: hidden;">Action</label>
          <button
            type="button"
            class="btn btn-primary btn-generate-action w-100"
            :disabled="isGenerating"
            @click="handleGenerate"
          >
            <i v-if="isGenerating" class="fas fa-spinner fa-spin mr-2"></i>
            <span>{{ isGenerating ? "Generating..." : "Generate" }}</span>
          </button>
        </div>
      </div>

      <!-- General Validation Error Alert if any -->
      <div v-if="validationErrors.general" class="alert alert-danger py-2 px-3 mt-1 mb-0 general-error-alert">
        <i class="fas fa-exclamation-circle mr-1"></i>
        <span>{{ validationErrors.general }}</span>
      </div>
    </div>
    <!-- Generate Data Card End -->

    <!-- Generated Files Section (PRD Section 12, 13) -->
    <div class="innerBox mt-4 generated-files-card">
      <!-- Section Header with Title & Refresh button -->
      <div class="d-flex justify-content-between align-items-start flex-wrap mb-3">
        <div>
          <h5 class="section-title mb-1">Generated Files</h5>
          <p class="section-helper-text mb-0">
            Generated files may take several minutes to prepare. You can leave this page and return later to download the file.
          </p>
        </div>
        <div class="mt-2 mt-sm-0">
          <button
            type="button"
            class="btn btn-outline-secondary btn-refresh-action"
            :disabled="isRefreshing || isLoadingHistory"
            @click="handleManualRefresh"
            title="Refresh status and list"
          >
            <i class="fas fa-sync-alt mr-1" :class="{ 'fa-spin': isRefreshing || isLoadingHistory }"></i>
            <span>Refresh</span>
          </button>
        </div>
      </div>

      <!-- Table Section -->
      <div class="mt-2 scan-history-table-wrapper">
        <div style="overflow-x: auto; overflow-y: hidden">
          <table class="table scan-history-table" style="margin: 0">
            <thead>
              <tr>
                <th class="text-left" style="min-width: 220px;">Date Range</th>
                <th class="text-left" style="min-width: 130px;">Requested By</th>
                <th class="text-left" style="min-width: 160px;">Requested At</th>
                <th class="text-left" style="min-width: 160px;">Generated At</th>
                <th class="text-center" style="min-width: 130px;">Status</th>
                <th class="text-center" style="min-width: 140px;">Action</th>
              </tr>
            </thead>
            <tbody>
              <!-- Loading State (PRD Section 25) -->
              <tr v-if="isLoadingHistory">
                <td colspan="6" class="text-center py-5">
                  <div class="d-flex flex-column align-items-center justify-content-center">
                    <div class="spinner-border text-primary mb-2" role="status" style="width: 2rem; height: 2rem;">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <span style="color: #676767; font-size: 13px;">Loading generated files...</span>
                  </div>
                </td>
              </tr>

              <!-- API Error State (PRD Section 26) -->
              <tr v-else-if="hasErrorHistory">
                <td colspan="6" class="text-center py-5">
                  <div class="text-danger mb-2">
                    <i class="fas fa-exclamation-triangle fa-2x"></i>
                  </div>
                  <p class="mb-2" style="color: #dc2626; font-weight: 500; font-size: 14px;">
                    Failed to load generated files.
                  </p>
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="handleManualRefresh">
                    <i class="fas fa-redo-alt mr-1"></i> Retry
                  </button>
                </td>
              </tr>

              <!-- Data Rows (PRD Section 13 - 20) -->
              <tr v-else-if="tableData.length > 0" v-for="item in tableData" :key="item.id">
                <!-- Date Range (DD MMM YYYY – DD MMM YYYY) -->
                <td class="text-left font-weight-500 text-dark">
                  {{ item.dateRange || '-' }}
                </td>

                <!-- Requested By -->
                <td class="text-left text-capitalize">
                  {{ item.requestedBy || '-' }}
                </td>

                <!-- Requested At (DD MMM YYYY HH:mm) -->
                <td class="text-left" style="white-space: nowrap;">
                  {{ item.requestedAt || '-' }}
                </td>

                <!-- Generated At (DD MMM YYYY HH:mm or -) -->
                <td class="text-left" style="white-space: nowrap;">
                  {{ item.generatedAt || '-' }}
                </td>

                <!-- Status Badge (Processing / Ready / Failed) -->
                <td class="text-center">
                  <span class="status-badge" :class="getStatusBadgeClass(item.status)">
                    <i v-if="item.status === 'Processing'" class="fas fa-spinner fa-spin mr-1"></i>
                    <i v-else-if="item.status === 'Ready'" class="fas fa-check-circle mr-1"></i>
                    <i v-else-if="item.status === 'Failed'" class="fas fa-times-circle mr-1"></i>
                    {{ item.status || '-' }}
                  </span>
                </td>

                <!-- Action (Download when Ready, - when Processing/Failed) -->
                <td class="text-center">
                  <button
                    v-if="item.status === 'Ready'"
                    type="button"
                    class="btn btn-sm btn-download-action"
                    :disabled="downloadingExportId === item.id"
                    @click="handleDownload(item)"
                    title="Download File"
                  >
                    <i
                      class="fas mr-1"
                      :class="downloadingExportId === item.id ? 'fa-spinner fa-spin' : 'fa-download'"
                    ></i>
                    <span>{{ downloadingExportId === item.id ? "Downloading..." : "Download" }}</span>
                  </button>
                  <span v-else class="text-muted text-action-empty">-</span>
                </td>
              </tr>

              <!-- Empty State (PRD Section 24) -->
              <tr v-else>
                <td colspan="6" class="text-center py-5">
                  <div class="empty-state-box py-3">
                    <div class="empty-state-icon-wrapper mb-2">
                      <i class="fas fa-file-excel fa-3x" style="color: #c5c7cb;"></i>
                    </div>
                    <h6 class="empty-state-title" style="font-weight: 600; color: #4b4b4b; margin-bottom: 4px;">
                      No generated files yet.
                    </h6>
                    <p class="empty-state-subtitle" style="color: #9d9d9d; font-size: 13px; margin-bottom: 0;">
                      Select a date range above and click Generate to create your first export.
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination (matching CustomerActivities.vue & PRD Section 38) -->
        <div class="row mt-3" v-if="!isLoadingHistory && !hasErrorHistory && total > 0">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
            <div class="d-flex align-items-center">
              <label for="items-per-page" style="margin-right: 8px; margin-bottom: 0; color: #a3a4a6; font-size: 14px">
                View
              </label>
              <select
                id="items-per-page"
                v-model="limitPerPage"
                @change="onLimitChange"
                class="form-control form-control-sm"
                style="width: auto; display: inline-block; padding: 4px 8px"
              >
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span style="margin-left: 8px; color: #a3a4a6; font-size: 14px">items per page</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <p class="mt-2 mb-2" style="color: #a3a4a6; margin-right: 20px; margin-bottom: 0">
                Showing {{ showingStart }}-{{ showingEnd }} of {{ total }} Items
              </p>
              <nav class="pagination-minimal">
                <ul class="pagination" style="margin: 0; flex-wrap: wrap">
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage <= 1 }"
                    @click.stop.prevent="changePage('prev')"
                  >
                    <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage >= maxPage }"
                    @click.stop.prevent="changePage('next')"
                  >
                    <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Generated Files Section End -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "InternalDataExport",
  metaInfo: {
    title: "Internal Data Export",
  },
  data() {
    return {
      user: this.$store.getters.currentUser,

      // Form state
      form: {
        startDate: "",
        endDate: "",
      },

      // Validation errors
      validationErrors: {
        startDate: "",
        endDate: "",
        general: "",
      },

      // Table Data & states
      tableData: [],
      total: 0,
      isGenerating: false,
      isLoadingHistory: false,
      isRefreshing: false,
      hasErrorHistory: false,
      downloadingExportId: null,

      // Filters & Sorting for GET /api/reports/internal-data-export/list?start&end&status&limit&page&by&order
      tableFilter: {
        start: "",
        end: "",
        status: "",
      },
      sortBy: "requested_at",
      sortOrder: "DESC",

      // Polling timer
      pollingTimer: null,

      // Flatpickr configs for separate Start and End Date
      startDateConfig: {
        mode: "single",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d M Y",
        altInputClass: "form-control input elegant-flatpickr",
        maxDate: "today",
      },
      endDateConfig: {
        mode: "single",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d M Y",
        altInputClass: "form-control input elegant-flatpickr",
        maxDate: "today",
      },

      // Pagination
      currentPage: 1,
      limitPerPage: 10,
    };
  },
  computed: {
    maxPage() {
      return Math.ceil(this.total / this.limitPerPage) || 1;
    },
    showingStart() {
      return this.total === 0 ? 0 : (this.currentPage - 1) * this.limitPerPage + 1;
    },
    showingEnd() {
      const end = this.currentPage * this.limitPerPage;
      return end < this.total ? end : this.total;
    },
    hasProcessingItems() {
      return this.tableData.some((item) => item.status === "Processing");
    },
  },
  mounted() {
    // Initial fetch of generated files
    this.fetchTableData();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    // Validation (PRD Section 10)
    validateForm() {
      this.validationErrors = {
        startDate: "",
        endDate: "",
        general: "",
      };

      let isValid = true;
      const today = moment().format("YYYY-MM-DD");

      if (!this.form.startDate) {
        this.validationErrors.startDate = "Start Date is required.";
        isValid = false;
      }

      if (!this.form.endDate) {
        this.validationErrors.endDate = "End Date is required.";
        isValid = false;
      }

      if (this.form.startDate && this.form.endDate) {
        if (this.form.startDate > this.form.endDate) {
          this.validationErrors.general = "Start Date cannot be later than End Date.";
          isValid = false;
        } else if (this.form.startDate > today || this.form.endDate > today) {
          this.validationErrors.general = "Future dates are not allowed.";
          isValid = false;
        }
      }

      return isValid;
    },

    handleStartDateChange(selectedDates, dateStr) {
      this.form.startDate = dateStr;
      this.validationErrors.startDate = "";
      this.validationErrors.general = "";
    },

    handleEndDateChange(selectedDates, dateStr) {
      this.form.endDate = dateStr;
      this.validationErrors.endDate = "";
      this.validationErrors.general = "";
    },

    clearStartDate() {
      this.form.startDate = "";
      this.validationErrors.startDate = "";
    },

    clearEndDate() {
      this.form.endDate = "";
      this.validationErrors.endDate = "";
    },

    // Format display for date range
    formatDateRange(start, end) {
      if (!start && !end) return "-";
      if (start && !end) return moment(start).format("DD MMM YYYY");
      if (!start && end) return moment(end).format("DD MMM YYYY");
      const startStr = moment(start).format("DD MMM YYYY");
      const endStr = moment(end).format("DD MMM YYYY");
      return `${startStr} – ${endStr}`;
    },

    // Normalize and map backend row data
    formatRow(row) {
      const startDate = row.start_date || row.startDate || "";
      const endDate = row.end_date || row.endDate || "";

      let dateRange = row.date_range || row.dateRange || "";
      if (!dateRange && (startDate || endDate)) {
        dateRange = this.formatDateRange(startDate, endDate);
      }

      // Normalize status: ready/completed -> Ready, processing/pending -> Processing, failed/error -> Failed
      let statusRaw = String(row.status || "Processing").toLowerCase();
      let status = "Processing";
      if (statusRaw === "ready" || statusRaw === "completed" || statusRaw === "success") {
        status = "Ready";
      } else if (statusRaw === "failed" || statusRaw === "error") {
        status = "Failed";
      } else {
        status = "Processing";
      }

      // Format timestamps
      const requestedAtRaw = row.requested_at || row.requestedAt || row.created_at || row.createdAt || "";
      let requestedAt = "-";
      if (requestedAtRaw) {
        requestedAt = moment(requestedAtRaw).isValid()
          ? moment(requestedAtRaw).format("DD MMM YYYY HH:mm")
          : requestedAtRaw;
      }

      const generatedAtRaw = row.generated_at || row.generatedAt || row.completed_at || row.finished_at || "";
      let generatedAt = "-";
      if (status === "Ready" && generatedAtRaw) {
        generatedAt = moment(generatedAtRaw).isValid()
          ? moment(generatedAtRaw).format("DD MMM YYYY HH:mm")
          : generatedAtRaw;
      }

      const requestedBy =
        row.requested_by ||
        row.requestedBy ||
        row.created_by ||
        row.user_name ||
        row.username ||
        (row.user && (row.user.name || row.user.username)) ||
        "-";

      return {
        id: row.id || row._id || (Math.random() + Date.now()),
        startDate,
        endDate,
        dateRange: dateRange || "-",
        requestedBy,
        requestedAt,
        generatedAt,
        status,
        fileSize: row.file_size || row.fileSize || "-",
        fileName: row.file_name || row.fileName || "",
        downloadUrl: row.download_url || row.downloadUrl || row.file_url || row.fileUrl || row.url || "",
        raw: row,
      };
    },

    // Fetch list from API: GET /api/reports/internal-data-export/list?start&end&status&limit&page&by&order
    async fetchTableData(options = {}) {
      const isPolling = options.isPolling || false;
      if (!isPolling) {
        this.isLoadingHistory = true;
      }
      this.hasErrorHistory = false;

      try {
        const queryParams = {
          start: this.tableFilter.start || "",
          end: this.tableFilter.end || "",
          status: this.tableFilter.status || "",
          limit: this.limitPerPage,
          page: this.currentPage,
          by: this.sortBy || "requested_at",
          order: this.sortOrder || "DESC",
        };

        const resp = await this.$http.get("/api/reports/internal-data-export/list", {
          params: queryParams,
        });

        console.log("[InternalDataExport] List Response:", resp.data);

        const rawData = (resp.data && (resp.data.data || resp.data.result || resp.data.list)) || [];
        const rows = Array.isArray(rawData)
          ? rawData
          : (rawData.rows || rawData.list || rawData.data || []);

        this.tableData = rows.map((row) => this.formatRow(row));

        // Parse pagination meta
        const meta = (resp.data && (resp.data.meta || resp.data.pagination)) || resp.data || {};
        this.total = Number.parseInt(
          meta.total !== undefined
            ? meta.total
            : meta.totalCount !== undefined
            ? meta.totalCount
            : meta.total_count !== undefined
            ? meta.total_count
            : meta.count !== undefined
            ? meta.count
            : this.tableData.length,
          10
        ) || 0;

        // Manage polling automatically based on whether items are still processing
        if (this.hasProcessingItems) {
          this.startPolling();
        } else {
          this.stopPolling();
        }
      } catch (err) {
        console.error("[InternalDataExport] Fetch List Error:", err);
        if (!isPolling) {
          this.hasErrorHistory = true;
        }
      } finally {
        if (!isPolling) {
          this.isLoadingHistory = false;
        }
        this.isRefreshing = false;
      }
    },

    // Generate Action: POST /api/reports/internal-data-export/generate
    async handleGenerate() {
      if (!this.validateForm()) {
        return;
      }

      this.isGenerating = true;

      try {
        const payload = {
          start_date: this.form.startDate,
          end_date: this.form.endDate,
        };

        const resp = await this.$http.post("/api/reports/internal-data-export/generate", payload);
        console.log("[InternalDataExport] Generate Response:", resp.data);

        // SweetAlert success notification
        this.$swal.fire({
          icon: "success",
          title: "Request Created",
          text:
            (resp.data && (resp.data.message || resp.data.msg)) ||
            "Export request has been created successfully.",
          timer: 2500,
          showConfirmButton: false,
        });

        // Reset to first page and reload table to display the newly queued job
        this.currentPage = 1;
        await this.fetchTableData();

        // Ensure polling starts to track the processing status
        this.startPolling();
      } catch (err) {
        console.error("[InternalDataExport] Generate Error:", err);
        const errMsg =
          (err.response &&
            err.response.data &&
            (err.response.data.message || err.response.data.msg || err.response.data.error)) ||
          "Failed to generate data. Please try again.";

        this.$swal.fire({
          icon: "error",
          title: "Generate Failed",
          text: errMsg,
        });
      } finally {
        this.isGenerating = false;
      }
    },

    // Polling management (PRD Section 21, 22)
    startPolling() {
      if (this.pollingTimer) return;

      this.pollingTimer = setInterval(() => {
        // Poll silently in background
        this.fetchTableData({ isPolling: true });
      }, 5000);
    },

    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },

    // Manual Refresh (PRD Section 23)
    handleManualRefresh() {
      this.isRefreshing = true;
      this.fetchTableData();
    },

    // Download Action (PRD Section 27)
    async handleDownload(item) {
      this.downloadingExportId = item.id;

      try {
        if (item.downloadUrl) {
          window.open(item.downloadUrl, "_blank");
        } else {
          // Default download endpoint
          const defaultUrl = `/api/reports/internal-data-export/download/${item.id}`;
          window.open(defaultUrl, "_blank");
        }

        this.$swal.fire({
          icon: "success",
          title: "Download Started",
          text: `Downloading export file for ${item.dateRange}...`,
          timer: 2200,
          showConfirmButton: false,
        });
      } catch (err) {
        console.error("[InternalDataExport] Download Error:", err);
        const errMsg =
          (err.response && err.response.data && (err.response.data.message || err.response.data.error)) ||
          "Failed to download file. Please try again.";

        this.$swal.fire({
          icon: "error",
          title: "Download Failed",
          text: errMsg,
        });
      } finally {
        this.downloadingExportId = null;
      }
    },

    // Status chip CSS class
    getStatusBadgeClass(status) {
      if (status === "Ready") return "badge-status-ready";
      if (status === "Processing") return "badge-status-processing";
      if (status === "Failed") return "badge-status-failed";
      return "badge-status-default";
    },

    // Pagination methods
    changePage(direction) {
      if (direction === "prev" && this.currentPage > 1) {
        this.currentPage--;
        this.fetchTableData();
      } else if (direction === "next" && this.currentPage < this.maxPage) {
        this.currentPage++;
        this.fetchTableData();
      }
    },

    onLimitChange() {
      this.currentPage = 1;
      this.fetchTableData();
    },
  },
};
</script>

<style scoped>
.download-report-container {
  padding: 4px;
}

/* Page Header */
.page-header-title {
  font-size: 18px;
  font-weight: 700;
  color: #333333;
  margin: 0 0 4px 0;
}

.page-header-subtitle {
  font-size: 13px;
  color: #9d9d9d;
  margin: 0;
}

/* InnerBox container */
.innerBox {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

/* Section Title */
.section-title {
  font-size: 15px;
  font-weight: 700;
  color: #333333;
  margin: 0;
}

.section-helper-text {
  font-size: 13px;
  color: #9d9d9d;
  line-height: 1.5;
}

/* Field labels */
.form-field-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #676767;
  margin-bottom: 6px;
}

/* Elegant Date Container */
.elegant-date-box {
  box-shadow: none !important;
  border-radius: 5px;
  height: 36px;
  border: 1px solid #e0e0e0;
  background: #ffffff;
  overflow: hidden;
  transition: border-color 0.2s;
}

.elegant-date-box:focus-within {
  border-color: #267ce5;
}

.elegant-date-box.has-field-error {
  border-color: #dc3545 !important;
}

.clear-date-btn {
  color: #9d9d9d;
  display: flex;
  align-items: center;
  text-decoration: none;
}

.clear-date-btn:hover {
  color: #dc3545;
}

.field-error-msg {
  display: block;
  font-size: 11px;
  margin-top: 4px;
}

.general-error-alert {
  font-size: 12px;
  border-radius: 5px;
}

/* Generate Button */
.btn-generate-action {
  height: 36px;
  box-shadow: none !important;
  border-radius: 5px;
  background-color: #267ce5 !important;
  border-color: #267ce5 !important;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.8px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-generate-action:hover:not(:disabled) {
  background-color: #1e6acc !important;
  border-color: #1e6acc !important;
}

.btn-generate-action:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* Refresh Button */
.btn-refresh-action {
  height: 34px;
  font-size: 12px;
  font-weight: 600;
  color: #676767;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: none !important;
}

.btn-refresh-action:hover:not(:disabled) {
  background-color: #f8fafc;
  border-color: #cbd5e1;
  color: #1e293b;
}

.btn-refresh-action:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Download Button */
.btn-download-action {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 4px;
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #2563eb;
  transition: all 0.15s ease-in-out;
  box-shadow: none !important;
}

.btn-download-action:hover:not(:disabled) {
  background-color: #2563eb;
  border-color: #2563eb;
  color: #ffffff;
}

.btn-download-action:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.text-action-empty {
  color: #9d9d9d;
  font-size: 14px;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 12px;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.badge-status-processing {
  background-color: #fffbeb;
  color: #b45309;
  border: 1px solid #fde68a;
}

.badge-status-ready {
  background-color: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
}

.badge-status-failed {
  background-color: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.badge-status-default {
  background-color: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

/* Table styling directly adopting CustomerActivities scan-history-table */
.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9d9d9d !important;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6 !important;
  border-top: none !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  padding: 12px 10px !important;
  white-space: nowrap;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4b4b4b !important;
  text-align: left;
  vertical-align: middle;
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: 1px solid #f2f4f8 !important;
  font-size: 13px !important;
  padding: 14px 10px !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Pagination Styles exactly matching CustomerActivities.vue */
.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4b4b4b;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 16px;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled):hover .page-link {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9d9d9d !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}
</style>
